import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SyncRcmMasterDataService {

  constructor(private http: HttpClient,
    private configService: ConfigService) { }

    masterTablesOptionsAPI =  "/api/gtmsttblopts";
    submitSelectedMasterTablesAPI =  "/api/sbmtmsttbls";
    getAllDataSyncRCM =  "/api/getalldata";
    getAllDataSyncRCMExcel =  "/api/genrtmsttblxls";

    GetMasterTablesOptions() {
      return this.http.get(this.masterTablesOptionsAPI);
    }

    SubmitSelectedMasterTables(tableIds: any) { 
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post(this.submitSelectedMasterTablesAPI, JSON.stringify(tableIds),{headers:headers});
  }

  getAllData(){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(this.getAllDataSyncRCM,{headers:headers});
  }

  GetSyncRcmDataToXLS(): Observable<Blob> {
    return this.http.get(this.getAllDataSyncRCMExcel, {
      responseType: 'blob'
    });
  }

}
